angular.module('main').directive('btnLgBlock', () => ({
	restrict: 'E',
	scope: {
		text: '@snText',
		color: '@snColor'
	},
	template: ` <button class="btn btn-lg btn-block btn-{{color}}">
                        {{text}}
                    </button>`,
	replace: true,
	transclude: true
}));



// WEBPACK FOOTER //
// ./web/js/components/Buttons/btnLgBlock.js